import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import '../../../scss/Components/_modal.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import { getToast } from '../../../utils/toastConfig';

function ModalCDelete(props) {
  const navigate = useNavigate();
  const {
    clientModalDeleteString,
    clientMDClientString,
    clientMDEDateString,
    modalYesString,
    modalNoString,
  } = useTranslationHook();

  var deleteClientBusiness = localStorage.getItem('clientBusinessToDelete');
  var deleteClientCreatedDate = localStorage.getItem(
    'clientCreatedDateToDelete'
  );

  var deleteClientId = localStorage.getItem('clientIdToDelete');

  function deleteClient() {
    customAxios
      .request({
        url: `${GlobalVariables.getURL()}deleteClient/${deleteClientId}`,
        method: 'delete',
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        console.log(response.data);
        hideS();
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Verifica si el error es 401 Unauthorized
          navigate('/nonauth'); // Redirige a la ruta de no autenticación

          localStorage.removeItem('token');
          localStorage.setItem('isAuthenticated', 'false');
        } else {
          getToast({
            status: 'error',
            title: 'Error al eliminar Plaza. Vuelve a intentarlo.',
          });
        }
      });
  }

  function hideS() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Plaza eliminada exitosamente en la base de datos.',
    });
    props.getClients();
  }

  function hideN() {
    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          ¿Quieres inactivar esta plaza?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="delete-info">
          <strong>{clientMDClientString}:</strong> {deleteClientBusiness}
        </span>
        <br />
        <span className="delete-info">
          <strong>{clientMDEDateString}:</strong> {deleteClientCreatedDate}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="modal-button"
          onClick={() => {
            deleteClient();
          }}
        >
          <FontAwesomeIcon icon={faWarning} /> Si, quiero inactivar esta plaza
        </button>
        <button
          className="modal-button no"
          onClick={() => {
            hideN();
          }}
        >
          <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCDelete;
